import { useEffect, useState } from "react";
import { CChart } from "@coreui/react-chartjs";
//import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities';
import { getJWT } from "../authentication/jwt";
import Overview from "../components/overview";
import UserStats from "../components/userStats";
import UserGraph from "../components/userGraph";
import UserLookup from "../components/userLookup";
import FormStats from "../components/formStats";
import FormLookup from "../components/formLookup";
import EmailSender from "../components/emailSender";

const Dashboard = () => {
  //Bar States
  const [topBarSelected, setTopBarSelected] = useState(1);
  const [overviewBarSelected, setOverviewBarSelected] = useState(1);
  const [userBarSelected, setUserBarSelected] = useState(1);
  const [welcomeFormBar, setWelcomeFormBar] = useState(1);
  const [emailBar, setEmailBar] = useState(1);
  const [articleBar, setArticleBar] = useState(1);
  const [coursesBar, setCoursesBar] = useState(1);
  const [quizzesBar, setQuizzesBar] = useState(1);
  const [revenueBar, setRevenueBar] = useState(1);
  const [promoBar, setPromoBar] = useState(1);

  //Loading Loading
  const [loading, setLoading] = useState(true);

  //Data States
  const [numUsers, setNumUsers] = useState(0);
  const [numVerifiedUsers, setNumVerifiedUsers] = useState(0);
  const [numForms, setNumForms] = useState(0);
  const [dateLabels, setDateLabels] = useState([]);
  const [amountEachDay, setAmountEachDay] = useState([]);
  const [forms, setForms] = useState([]);
  const [formNum, setFormNum] = useState(0);
  const [users, setUsers] = useState([]);

  const populateData = async () => {
    setLoading(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + getJWT());

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    let res1 = await fetch(
      process.env.REACT_APP_API_URL + "/user/stats",
      requestOptions
    );
    let userStats = await res1.json();

    setNumUsers(userStats.userCount);
    setNumVerifiedUsers(userStats.verifiedUserCount);
    setUsers(userStats.userList);

    var date = new Date();

    date.setDate(date.getDate() - 30);

    date.setHours(0, 0, 0, 0);

    let userSignupDates = userStats.userDates;

    let dateArray = [];
    let countArray = [];

    var nextDay = new Date();
    nextDay.setDate(nextDay.getDate() - 29);
    nextDay.setHours(0, 0, 0, 0);

    for (let i = 0; i < 31; i++) {
      dateArray.push(date.toDateString());
      let count = 0;
      for (let j = 0; j < userSignupDates.length; j++) {
        let givenDate = new Date(userSignupDates[j]);
        if (
          date.valueOf() <= givenDate.valueOf() &&
          givenDate.valueOf() <= nextDay.valueOf()
        ) {
          count++;
        }
      }
      countArray.push(count);
      nextDay.setDate(nextDay.getDate() + 1);
      date.setDate(date.getDate() + 1);
    }

    setDateLabels(dateArray);
    setAmountEachDay(countArray);

    let res2 = await fetch(
      process.env.REACT_APP_API_URL + "/forms/getForms",
      requestOptions
    );
    let forms = await res2.json();

    setNumForms(forms.forms.length);

    setForms(forms.forms);

    setLoading(false);
  };

  useEffect(() => {
    populateData();
  }, []);

  return (
    <div>
      <div className="flex mt-8 mb-8 justify-between   mr-24 ml-24">
        <h1 className="text-2xl">Welcome to the Dashboard!</h1>
        <button
          onClick={populateData}
          className="bg-black text-white px-3 py-1 rounded-lg self-center"
        >
          {loading ? (
            <svg
              aria-hidden="true"
              class="w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          ) : (
            "Refresh"
          )}
        </button>
      </div>
      <div className="my-4 mx-24">
        <div className="flex">
          <button
            onClick={() => setTopBarSelected(1)}
            className={
              topBarSelected == 1
                ? "text-white bg-black p-1 px-2 rounded-t-lg"
                : "p-1 px-2 rounded-t-lg hover:bg-hover"
            }
          >
            Overview
          </button>
          <button
            onClick={() => setTopBarSelected(2)}
            className={
              topBarSelected == 2
                ? "text-white bg-black p-1 px-2 rounded-t-lg"
                : "p-1 px-2 rounded-t-lg hover:bg-hover"
            }
          >
            Users
          </button>
          <button
            onClick={() => setTopBarSelected(3)}
            className={
              topBarSelected == 3
                ? "text-white bg-black p-1 px-2 rounded-t-lg"
                : "p-1 px-2 rounded-t-lg hover:bg-hover"
            }
          >
            Welcome Form
          </button>
          <button
            onClick={() => setTopBarSelected(4)}
            className={
              topBarSelected == 4
                ? "text-white bg-black p-1 px-2 rounded-t-lg"
                : "p-1 px-2 rounded-t-lg hover:bg-hover"
            }
          >
            Emails
          </button>
          <button
            onClick={() => setTopBarSelected(5)}
            className={
              topBarSelected == 5
                ? "text-white bg-black p-1 px-2 rounded-t-lg"
                : "p-1 px-2 rounded-t-lg hover:bg-hover"
            }
          >
            Articles
          </button>
          <button
            onClick={() => setTopBarSelected(6)}
            className={
              topBarSelected == 6
                ? "text-white bg-black p-1 px-2 rounded-t-lg"
                : "p-1 px-2 rounded-t-lg hover:bg-hover"
            }
          >
            Courses
          </button>
          <button
            onClick={() => setTopBarSelected(7)}
            className={
              topBarSelected == 7
                ? "text-white bg-black p-1 px-2 rounded-t-lg"
                : "p-1 px-2 rounded-t-lg hover:bg-hover"
            }
          >
            Quizzes
          </button>
          <button
            onClick={() => setTopBarSelected(8)}
            className={
              topBarSelected == 8
                ? "text-white bg-black p-1 px-2 rounded-t-lg"
                : "p-1 px-2 rounded-t-lg hover:bg-hover"
            }
          >
            Revenue
          </button>
          <button
            onClick={() => setTopBarSelected(9)}
            className={
              topBarSelected == 9
                ? "text-white bg-black p-1 px-2 rounded-t-lg"
                : "p-1 px-2 rounded-t-lg hover:bg-hover"
            }
          >
            Promotions
          </button>
        </div>
        <div className="border-2 border-black"></div>
        <div className="flex">
          {
            {
              1: (
                <button
                  onClick={() => setOverviewBarSelected(1)}
                  className={
                    overviewBarSelected == 1
                      ? "text-white bg-black p-1 px-2 rounded-b-lg"
                      : "p-1 px-2 rounded-b-lg hover:bg-hover"
                  }
                >
                  Stats
                </button>
              ),
              2: (
                <div>
                  <button
                    onClick={() => setUserBarSelected(1)}
                    className={
                      userBarSelected == 1
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Stats
                  </button>
                  <button
                    onClick={() => setUserBarSelected(2)}
                    className={
                      userBarSelected == 2
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Chart
                  </button>
                  <button
                    onClick={() => setUserBarSelected(3)}
                    className={
                      userBarSelected == 3
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    User Lookup
                  </button>
                </div>
              ),
              3: (
                <div>
                  {" "}
                  <button
                    onClick={() => setWelcomeFormBar(1)}
                    className={
                      welcomeFormBar == 1
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Stats
                  </button>
                  <button
                    onClick={() => setWelcomeFormBar(2)}
                    className={
                      welcomeFormBar == 2
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    View Forms
                  </button>
                </div>
              ),
              4: (
                <div>
                  {" "}
                  <button
                    onClick={() => setEmailBar(1)}
                    className={
                      emailBar == 1
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Send Email
                  </button>
                </div>
              ),
              5: (
                <div>
                  {" "}
                  <button
                    onClick={() => setArticleBar(1)}
                    className={
                      articleBar == 1
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Stats
                  </button>
                  <button
                    onClick={() => setArticleBar(2)}
                    className={
                      articleBar == 2
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Post
                  </button>
                  <button
                    onClick={() => setArticleBar(3)}
                    className={
                      articleBar == 3
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => setArticleBar(4)}
                    className={
                      articleBar == 4
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Recent Articles
                  </button>
                </div>
              ),
              6: (
                <div>
                  {" "}
                  <button
                    onClick={() => setCoursesBar(1)}
                    className={
                      coursesBar == 1
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Stats
                  </button>
                  <button
                    onClick={() => setCoursesBar(2)}
                    className={
                      coursesBar == 2
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Create Course
                  </button>
                  <button
                    onClick={() => setCoursesBar(3)}
                    className={
                      coursesBar == 3
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Add to Course
                  </button>
                  <button
                    onClick={() => setCoursesBar(4)}
                    className={
                      coursesBar == 4
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Edit Course
                  </button>
                </div>
              ),
              7: (
                <div>
                  {" "}
                  <button
                    onClick={() => setQuizzesBar(1)}
                    className={
                      quizzesBar == 1
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Stats
                  </button>
                  <button
                    onClick={() => setQuizzesBar(2)}
                    className={
                      quizzesBar == 2
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Create Quiz
                  </button>
                  <button
                    onClick={() => setQuizzesBar(3)}
                    className={
                      quizzesBar == 3
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Edit Quiz
                  </button>
                </div>
              ),
              8: (
                <div>
                  {" "}
                  <button
                    onClick={() => setRevenueBar(1)}
                    className={
                      revenueBar == 1
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Stats
                  </button>
                  <button
                    onClick={() => setRevenueBar(2)}
                    className={
                      revenueBar == 2
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Chart
                  </button>
                  <button
                    onClick={() => setRevenueBar(3)}
                    className={
                      revenueBar == 3
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Transaction History
                  </button>
                </div>
              ),
              9: (
                <div>
                  {" "}
                  <button
                    onClick={() => setPromoBar(1)}
                    className={
                      promoBar == 1
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Stats
                  </button>
                  <button
                    onClick={() => setPromoBar(2)}
                    className={
                      promoBar == 2
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Create Promo
                  </button>
                  <button
                    onClick={() => setPromoBar(3)}
                    className={
                      promoBar == 3
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Edit Promo
                  </button>
                  <button
                    onClick={() => setPromoBar(4)}
                    className={
                      promoBar == 4
                        ? "text-white bg-black p-1 px-2 rounded-b-lg"
                        : "p-1 px-2 rounded-b-lg hover:bg-hover"
                    }
                  >
                    Promo History
                  </button>
                </div>
              ),
            }[topBarSelected]
          }
        </div>
      </div>
      {topBarSelected == 1 && overviewBarSelected == 1 ? (
        <Overview
          loading={loading}
          userCount={numUsers}
          verifiedUserCount={numVerifiedUsers}
          totalMembers={0}
          revenue={0}
          articlesRead={0}
          formsAnswered={numForms}
          quizzesTaken={0}
        />
      ) : topBarSelected == 2 ? (
        {
          1: (
            <UserStats
              loading={loading}
              userCount={numUsers}
              verifiedUserCount={numVerifiedUsers}
              totalMembers={0}
            />
          ),
          2: (
            <UserGraph dateLabels={dateLabels} amountEachDay={amountEachDay} />
          ),
          3: (
            <UserLookup
              loading={loading}
              users={users}
              populateData={populateData}
            />
          ),
        }[userBarSelected]
      ) : topBarSelected == 3 ? (
        { 1: <FormStats loading={loading} formCount={numForms} userCount={numUsers} /> , 2: <FormLookup forms={forms} users={users}/> }[
          welcomeFormBar
        ]
      ) : topBarSelected == 4 ? <EmailSender/> : (
        <div></div>
      )}
    </div>
  );
};

export default Dashboard;
